import { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { rem } from 'polished'

import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'

export type TripChatMobileTabId = 'chat' | 'list' | 'map'

export interface TripChatMobileTabItem {
  id: TripChatMobileTabId
  label: string
}

interface TripChatMobileTabsProps {
  activeTab: TripChatMobileTabId
  ariaLabel: string
  tabs: ReadonlyArray<TripChatMobileTabItem>
  onTabChange: (tabId: TripChatMobileTabId) => void
  inlineOnWideScreens?: boolean
}

const SegmentedOptionsRegion = styled.div<{ $inlineOnWideScreens: boolean }>`
  display: flex;
  flex-shrink: 0;
  min-height: ${rem(56)};
  align-items: center;
  padding: ${rem(8)} ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};

  > * {
    width: 100%;
  }

  ${props => props.$inlineOnWideScreens && css`
    @media (min-width: ${rem(350)}) {
      min-height: ${rem(60)};
      padding-inline: ${rem(4)};
    }
  `}
`

interface TripChatMobileTabOptionProps {
  activeTab: TripChatMobileTabId
  tab: TripChatMobileTabItem
}

function TripChatMobileTabOption({ activeTab, tab }: TripChatMobileTabOptionProps) {
  return (
    <SegmentedOption
      value={tab.id}
      title={tab.label}
      checked={activeTab === tab.id}
    />
  )
}

function TripChatMobileTabs({ activeTab, ariaLabel, tabs, onTabChange, inlineOnWideScreens = false }: TripChatMobileTabsProps) {
  const options = useMemo(() => tabs.map(tab => (
    <TripChatMobileTabOption
      key={tab.id}
      activeTab={activeTab}
      tab={tab}
    />
  )), [activeTab, tabs])

  return (
    <SegmentedOptionsRegion $inlineOnWideScreens={inlineOnWideScreens} role="group" aria-label={ariaLabel}>
      <SegmentedOptionsGroup<TripChatMobileTabId>
        inputsName="trip-chat-mobile-view"
        distribution="filled"
        onValueChange={onTabChange}
      >
        {options}
      </SegmentedOptionsGroup>
    </SegmentedOptionsRegion>
  )
}

export default TripChatMobileTabs
